function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0enviarIcon{fill: #243165;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0enviarIcon",
  d: "M19.4,0l.8.3L1.1,10c-.3.1-.6.3-.8.7,0,.1-.1.3-.2.4v.2c0,0,0,.4,0,.4v.2c0,.1.1.2.2.3.1.3.3.5.6.7l4,2.5c.5.3.9.6,1.3.8v4.1c0,.6.3,1,.9,1.2h0s.4,0,.4,0c.4,0,.6-.3.8-.5l.9-.9c.4-.4.8-.8,1.2-1.3,1.3.8,2.6,1.6,3.9,2.4.1,0,.3.1.4.2,0,0,.1,0,.2,0h.4s.2,0,.2,0c.1,0,.3,0,.4-.1.4-.2.7-.6.8-1,.2-.8.4-1.6.6-2.3L21.2,1.8c0,0,0-.2,0-.2l.2.6V0h-2.1ZM19.5,3.1l-3.9,15.8c0,.3-.2.7-.2,1,0,0,0,.2-.1.2,0,0-.2,0-.2,0-.6-.4-1.2-.7-1.8-1.1l-5.3-3.3L19.5,3.1ZM17.7,3.1L6.7,14.9l-2-1.2c-1.1-.7-2.1-1.3-3.2-2-.1,0-.1-.1-.1-.2,0,0,0-.1.2-.2l4.8-2.4,11.4-5.8ZM9.2,18.1l-1.7,1.7v-2.7l1.7,1Z"
})));

var SvgEnviar = function SvgEnviar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "enviarIcon",
    viewBox: "0 0 21.5 21.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnviar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/enviar.13c195b8.svg";
export { ForwardRef as ReactComponent };